export const thousands = number => {
  if (number === null || number === undefined) return number || '-';

  const arr = String(number).split('.');

  return arr.map(s => s.replace(/(?=(?!\b)(\d{3})+$)/g, ',')).join('.');
};

export const formatAmount = num => Math.round(num * 100) / 100;
